import "@stream-io/video-react-sdk/dist/css/styles.css";
import React, { Suspense } from 'react';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import store, { queryClient } from './redux/store';
import router from './routesConfig';
import 'react-toastify/dist/ReactToastify.css';
import { StreamClientProvider } from './provider/StreamClientProvider';
import { CallProvider } from './provider/CallProvider';
import { RevenueCatProvider } from './provider/RevenueCatProvider';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { QueryClientProvider } from '@tanstack/react-query';
import NotificationProvider from "./provider/NotificationProvider";
import CookieConsent from "./Components/CookieConsent/CookieConsent";

const App = () => {
  return (
    <Provider store={store}>
      <CookieConsent />
      <ToastContainer
        position="top-center"
        hideProgressBar={true}
        autoClose={3000}
        bodyStyle={{ backgroundColor: '#000000' }}
        toastStyle={{ backgroundColor: '#000000' }}
      />
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENTID}>
        <QueryClientProvider client={queryClient}>
          <RevenueCatProvider>
            <NotificationProvider>
              <StreamClientProvider>
                <CallProvider>
                  <Suspense>
                    <RouterProvider router={router} />
                  </Suspense>
                </CallProvider>
              </StreamClientProvider>
            </NotificationProvider>
          </RevenueCatProvider>
        </QueryClientProvider>
      </GoogleOAuthProvider>
    </Provider>
  );
};
export default App;
